import { Component, OnInit, OnDestroy, Output, EventEmitter,ViewChild,TemplateRef  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Dep } from '../class/auth';
import * as moment from 'moment';
import { Rtable } from '../class/rtabledata';
import * as Highcharts from "highcharts";
import { Options } from "highcharts";
import { chartdata } from "../class/chatdata";
import { NgbModal,NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-agentmember',
    templateUrl: './agentmember.component.html',
    styleUrls: ['./agentmember.component.css'],

})
export class AgentmemberComponent implements OnInit, OnDestroy {

    private boundResizeHandler = () => { this.checkDeviceType(); };

    ngOnDestroy(): void {
        window.removeEventListener('resize', this.boundResizeHandler);
    }
    private modalRef!: NgbModalRef; // 保存模态框的引用
    @ViewChild('yourModalContent', { read: TemplateRef }) yourModalContent: TemplateRef<any>;
    @ViewChild('yourModalContent2', { read: TemplateRef }) yourModalContent2: TemplateRef<any>;
    @ViewChild('yourModalContent3', { read: TemplateRef }) yourModalContent3: TemplateRef<any>;
    @ViewChild('brokerModal', { read: TemplateRef }) brokerModal: TemplateRef<any>;


    constructor(
        private cdr: ChangeDetectorRef,
        public httpClient: HttpClient,
        private modalService: NgbModal,
        private  route: ActivatedRoute,

    ){
        this.setMinAndMaxDates();
    }
    invites:any = true;
    user_item:any = [];
    Highcharts: typeof Highcharts = Highcharts;
    pieOptions: any =  JSON.parse(JSON.stringify(chartdata.pie));
    pieOptions2: any =  JSON.parse(JSON.stringify(chartdata.pie));
    pieOptions3: any =  JSON.parse(JSON.stringify(chartdata.pie));
    pieOptions4: any =  JSON.parse(JSON.stringify(chartdata.pie));
    isDesktop: boolean;
    link:string = environment.link;
    iconPic:string = environment.picfile+'icon-app.png';
    now:string = '6';
    subnow:string = '0';
    sublist_now:string = '9';
    subnow_menu:string = '0';
    default_time:boolean = true;
    subnow_menu_data:menulist = [];
    vid:string = '-1';
    status_man = false;
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    }

    vtype:any = '0';

    vendor_type_list:menulist = [
        {id:'0',name:'全部'},
        {id:'1',name:'內部經紀'},
        {id:'2',name:'外部經紀 '}
    ];


    sub_menu_list:menulist = [
        // {id:'0',name:'用戶收益'},
        {id:'9',name:'人員收益狀況'},
        {id:'1',name:'用戶活躍'}
    ];

    diamond_detail:any = {};
    diamod_type_list = [{id:'1',name:'個人'},{id:'2',name:'經紀'}];
    menu_list:menulist = [
        {id:'6',name:'每日統計'},
        // {id:'7',name:'經紀人員收入來源比例'},
        {id:'8',name:'經紀人員活動排名狀況'},
        // {id:'3',name:'每日統計'},
        {id:'0',name:'人員列表'},
        {id:'4',name:'提領對帳表'},
        {id:'5',name:'人員狀態'},
        // {id:'10',name:'停權提領'},
        // {id:'9',name:'人員收益狀況'}
        // {id:'1',name:'人員績效'}
        // ,{id:'2',name:'新增人員'}
    ]
    sort_list_for_mb:menulist = [
        {id:'now_round_diamond',name:'本期鑽石收益'},
        {id:'last_round_diamond',name:'上期鑽石收益'},
        {id:'last_round_money',name:'上期提領'},
        {id:'total_diamond',name:'累計鑽石'},
        {id:'total_money',name:'累計提領'},
        {id:'sort_obj',name:'交易對象'},
    ]

    dayOfMonth:any = '';
    all_vendor_list: menulist = []
    vendor_list:menulist = []
    rank_announce_list:menulist = []
    search_model:string = '';
    search_lv:string = '';
    search_status:string = '';
    search_trasnfer_status:string = '99';
    search_health_fee:string = '';
    search_account_memo:string = '';
    search_offline_day = 0;
    search_withdrawal_status:string = '-1';
    sort_obj:any = {column:'login_time',sort:'0'}
    data:any=[];
    active_info:any=[];
    posts_attributes:any=[];
    posts_input:any=[];
    now_vinfo:any=[];
    edit_data:any=[];
    round_info:any=[];
    fuck_item:any=[];
    urltoken :string = '';
    urltoken2 :string = '';
    urltoken3 :string = '';
    urltoken4 :string = '';
    urltoken5 :string = '';
    urltoken6 :string = '';
    urltoken7 :string = '';
    urltoken8 :string = '';
    preurl :string = '';
    serverExcelurl:string = '';
    loading:boolean=true;

    pageobj:page = {page:0,count:12,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));

    pageobj2:page = {page:0,count:20,total_count:0};
    pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2));

    pageobj3:page = {page:0,count:20,total_count:0};
    pageobjstr3:string=JSON.parse(JSON.stringify(this.pageobj3));

    pageobj4:page = {page:0,count:20,total_count:0};
    pageobjstr4:string=JSON.parse(JSON.stringify(this.pageobj4));

    historySettingPageObj:page = {page:0,count:10,total_count:0};
    historySettingPageObjStr:string = JSON.parse(JSON.stringify(this.pageobj))

    serial_data:any=[];
    serial_input:any=[];
    serial_attributes:any=[];
    serial_pageobj:page = {page:0,count:20,total_count:300};
    serial_pageobjstr:string=JSON.parse(JSON.stringify(this.serial_pageobj))
    edit_serial_data:any=[];
    search_serial:string = '';
    current_month:string = moment().subtract(1, 'month').format('YYYY-MM');
    current_monthed:string = moment().subtract(1, 'month').format('YYYY-MM');
    daily_income:any = 0;
    memo:any=[];
    accounting_memo:string = '';
    accounting_data:any=[];
    updateFlag:boolean=false;
    serizedata:any=[];
    serizedata2:any=[];
    serizedata3:any=[];
    serizedata4:any=[];
    tcontent2:any=[];
    // historySettingTcontent: any = [];
    tcontent2x:any=[];
    serizedetaildata:any=[];
    serizedataTotal = 0;
    detail_type = 1;
    detailnember_type = -1;
    all_nember = 0;
    vendor_update_time = '';
    monthRange = '';
    serizedatatotal = 0;
    serizedata2total = 0;
    serizedat3total = 0;
    serizedata4total = 0;
    numBan = 0;
    rank_data = [];
    alls_user_id = [];
    set_profile:any = [];
    total = {'total_income':0,'text_income':0,'voice_income':0,'video_income':0,'album_income':0,'game_income':0,'active_reward':0,'gift_reward':0,'live_reward':0,'date_reward':0,'voice_room_income':0,'donate_income':0,'other':0};
    rankcontent = [
        {title:'名稱',content:'name'},
        {title:'活動名稱',content:'title'},
        {title:'分區排名',content:'user_rank_lv'},
        {title:'用戶活動排名',content:'rank'},
    ];

    historySettingTcontent = [  //歷史設定數值
        {title:'設定人',content:'settingEmpName'},
        {title:'🌟 精選動態目標數',content:'featured_post_target'},
        {title:'📩 每日群發目標數',content:'daily_mass_message_target'},
        {title:'💰 每月目標業績額',content:'monthly_target'},
        {title:'🎯 每月招募數目標',content:'recruitment_target'},
        {title:'設定日期',content:'create_dt'},
    ]
    historySettingContent = [];
    vendorDailySummary = [];
    vendorEmpNumlineOptions: Highcharts.Options = {
        chart: {
          type: 'line'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          title: {
            text: '日期'
          }
        },
        yAxis: {
          title: {
            text: '成員數量'
          }
        },
        series: [],
        credits: {
          enabled: false // 移除 Highcharts 版權標記
        }
      };

    vendorEmpNumUpdateFlag: boolean = false;
    selectedDays: number = 7; // 預設查詢天數
    availableDays: number[] = [7, 14, 30, 90, 180, 360]; // 可選擇的天數
    vendorDailyEmpNum: any = []; // 存放 API 獲取的數據
    vendorNames: any = {}; // 存放經紀商 ID 與名稱對應關係
    userPowerId: number = Dep.user.powers.power_id;

    // ── 壽星 ──
    birthday_list_raw: any[] = [];
    birthday_week = '';
    birthday_count = 0;
    birthday_loading = false;
    birthday_collapsed = true;
    birthday_sort_field = 'birthday';  // 'birthday' | 'income' | 'name'
    birthday_sort_dir = 'asc';         // 'asc' | 'desc'
    birthday_view = 'card';       // 'card' | 'table'
    bd_time: any = {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek')
    };
    bd_timeset = [
        { type: 1, name: '本周', num: -0 },
        { type: 1, name: '過去7天', num: -7 },
        { type: 2, name: '本月', num: 0 },
        { type: 2, name: '上個月', num: -1 },
    ];
    bd_date_start = moment().startOf('isoWeek').format('YYYY-MM-DD');
    bd_date_end = moment().endOf('isoWeek').format('YYYY-MM-DD');
    bd_income_start = moment().startOf('month').format('YYYY-MM-DD');
    bd_income_end = moment().format('YYYY-MM-DD');
    bd_reward_note = '';
    bd_search_keyword = '';
    bd_filter_reward = '';  // '' | '0' | '1' | '2'

    get birthday_list(): any[] {
        let list = [...this.birthday_list_raw];

        // 搜尋篩選
        if (this.bd_search_keyword) {
            const kw = this.bd_search_keyword.toLowerCase().trim();
            list = list.filter((b: any) =>
                (b.name || '').toLowerCase().includes(kw) ||
                (b.uid || '').toLowerCase().includes(kw) ||
                (b.phone_num || '').toLowerCase().includes(kw)
            );
        }

        // 獎勵狀態篩選
        if (this.bd_filter_reward !== '') {
            const fs = parseInt(this.bd_filter_reward, 10);
            list = list.filter((b: any) => b.reward_status === fs);
        }

        // 排序
        const dir = this.birthday_sort_dir === 'desc' ? -1 : 1;
        switch (this.birthday_sort_field) {
            case 'income':
                list.sort((a, b) => (a.total_income - b.total_income) * dir);
                break;
            case 'name':
                list.sort((a, b) => (a.name || '').localeCompare(b.name || '') * dir);
                break;
            case 'birthday':
            default:
                list.sort((a, b) => (a.birthday_md || '').localeCompare(b.birthday_md || '') * dir);
                break;
        }
        return list;
    }

    get birthday_marked_count(): number {
        return this.birthday_list_raw.filter(b => b.reward_status === 1).length;
    }
    get birthday_sent_count(): number {
        return this.birthday_list_raw.filter(b => b.reward_status === 2).length;
    }

    tcontent = [
        {title:'時間',content:'sourcetime'},
        {title:'人數',content:'sourcecount',type:3},
    ];

    tcontent1x = [
        {title:'時間',content:'linetime'},
        {title:'人數',content:'lineount',type:3},
    ];

    tcontent1 = [
        {title:'名稱',content:'name',type:2},
        {title:'時間(小時)',content:'login_times_front',type:3},
    ];

    key:any = 0;
    detailstatus = 0;
    detailnemberstatus = 0;
    nowMonth= '';
    rank_announce_select = '1';
    diamond_data = [
        {'diamond':'500','month':'2024-06','remark':''},
        {'diamond':'-500','month':'2024-07','remark':''},
    ];

    money_data:any = [
        {'all_diamond':0,'diamond':'500','exchange_rate':1,'month':'2024-06','remark':''},
        {'all_diamond':1,'diamond':'全部','exchange_rate':2,'month':'2024-07','remark':''},
    ];

    tcontent_diamond = [
        {title:'鑽石',content:'diamond'},
        {title:'月份',content:'month'},
        {title:'備註',content:'remark'},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent_money = [
        {title:'鑽石',content:'diamond',type:3},
        // {title:'匯率',content:'exchange_rate',type:3},
        // {title:'月份',content:'month'},
        {title:'備註',content:'remark'},
        {title:'操作',content:'gg',type:3},
    ];

    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 },{ type:2 , name: "本月", num: 0} ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
    times:any={};
    showDatePickersTatus = true;

    diamond_type = 0;
    diamod_type = '-2';

    diamond = '';

    diamod_month = '-2';
    diamod_month_list = [];

    range_status = 0;
    diamondagenttextarea = '';
    moneyagenttextarea = '';
    outstatus = 0;

    incomecontent= [
        {title:'排名',content:'rank'},
        {title:'名稱',content:'name',type:2},
        {title:'大頭貼',content:'profile_pic',type:1},
        {title:'電話號碼',content:'phone_num',sort:'other',css:'min-width: 130px;'},
        {title:'用戶狀態',content:'is_enable',sort:'other',css:'min-width: 130px;',type:3},
        {title:'經紀狀態',content:'status',sort:'other',css:'min-width: 130px;',type:3},
        {title:'總收益',content:'total_income',sort:'total_income',css:'min-width: 130px;'},
        {title:'文字收益',content:'text_income',sort:'text_income',css:'min-width: 130px;'},
        {title:'語音收益',content:'voice_income',sort:'voice_income',css:'min-width: 130px;'},
        {title:'視訊收益',content:'video_income',sort:'video_income',css:'min-width: 130px;'},
        {title:'相簿收益',content:'album_income',sort:'album_income',css:'min-width: 130px;'},
        {title:'遊戲收益',content:'game_income',sort:'game_income',css:'min-width: 130px;'},
        {title:'活動獎勵',content:'active_reward',sort:'active_reward',css:'min-width: 130px;'},
        {title:'禮物收益',content:'gift_reward',sort:'gift_reward',css:'min-width: 130px;'},
        {title:'直播收益',content:'live_reward',sort:'live_reward',css:'min-width: 130px;'},
        {title:'約會收益',content:'date_reward',sort:'date_reward',css:'min-width: 130px;'},
        {title:'語音房收益',content:'voice_room_income',sort:'voice_room_income',css:'min-width: 130px;'},
        {title:'聊天室紅包收益',content:'donate_income',sort:'donate_income',css:'min-width: 150px;'},
        {title:'其他收益',content:'other',sort:'other',css:'min-width: 130px;'},
    ];

    withdrawalcontent = [
        {title:'淘妹名稱',content:'name',type:2},
        {title:'結算月份',content:'money_month'},
        {title:'電話',content:'phone_num'},
        {title:'收款行通匯代碼',content:'bank_value'},
        {title:'收款人帳號',content:'bank_account'},
        {title:'結算金額',content:'money'},
        {title:'姓名',content:'id_name'},
        {title:'地址',content:'permanent_addr'},
        {title:'身分證',content:'id_number'},
        {title:'結算狀態',content:'status',type:3},
        {title:'提領方式設定',content:'action',type:3},
        {title:'提領狀態',content:'actual_withdrawal_status',type:3},
        {title:'提領月份',content:'withdrawal_month',type:3},
        {title:'個人資料設定',content:'gg',type:3},
        // {title:'保存',content:'save',type:3},
    ];

    cal_money_data = [];
    thismonth:any = '';
    withdrawal_month_optionall:any = [];
    withdrawal_month_option:any = [
        {id:'1',name:'1月'},
        {id:'2',name:'2月'},
        {id:'3',name:'3月'},
        {id:'4',name:'4月'},
        {id:'5',name:'5月'},
        {id:'6',name:'6月'},
        {id:'7',name:'7月'},
        {id:'8',name:'8月'},
        {id:'9',name:'9月'},
        {id:'10',name:'10月'},
        {id:'11',name:'11月'},
        {id:'12',name:'12月'},
    ]

    enable_type = 0
    selectedDateTime: string;
    withdrawal_changes = '';
    withdrawal_changes_to = '';
    edit_profile:any = {id_number:'',id_name:'',permanent_addr:'',id_card:'',id_cardback:'',healthy_fee_cn:0,memo:''};
    urlexporttoken = '';
    // bank_statement_data:any=[];
    // bank_statement_input:any=[];
    // bank_statement_attributes:any=[];
    // bank_statement_pageobj:page = {page:0,count:20,total_count:300};
    // bank_statement_pageobjstr:string=JSON.parse(JSON.stringify(this.bank_statement_pageobj))
    // edit_bank_statement_data:any=[];
    // search_bank_statement:string = '';

    time :{startDate:any,endDate:any,start:string,end:string,minDate:any,maxDate:any} = {
        startDate:moment().subtract(7, 'days'),
        endDate:moment().subtract(0, 'days'),
        start:moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end:moment().subtract(0, 'days').format('YYYY-MM-DD'),
        minDate:moment().subtract(40, 'days').format('YYYY-MM-DD'),
        maxDate:moment().subtract(0, 'days').format('YYYY-MM-DD'),
    }
    minDate: string;
    maxDate: string;
    inputFields: { value: string; userItem?: any;country_value:string }[] = [{ value: '', userItem: null ,country_value:'886'}];
    add_inputFields: { value: string; userItem?: any;country_value:string }[] = [];


    selectedVendors: string[] = [];
    isExpanded = false; // 控制展開/收起狀態

    isProcessing = false;
    currentProgress = 0;
    totalProgress = 0;
    processingDelay = 15000; // 15秒延遲
    startTime: number = 0; // 記錄開始時間

    // 切換展開/收起狀態
    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
    }

    // 取得可選擇的經紀（排除 "全部" 選項）
    getSelectableVendors() {
        return this.vendor_list.filter(vendor => vendor.id !== '-1');
    }

    // 檢查經紀是否被選中
    isSelected(vendorId: string): boolean {
        return this.selectedVendors.includes(vendorId);
    }

    // 處理經紀選擇變更
    onVendorChange(event: any, vendor: any) {
        const vendorId = vendor.id;
        if (event.target.checked) {
            if (!this.selectedVendors.includes(vendorId)) {
                this.selectedVendors.push(vendorId);
            }
        } else {
            this.selectedVendors = this.selectedVendors.filter(id => id !== vendorId);
        }
    }

    // 全選
    selectAll() {
        this.selectedVendors = this.getSelectableVendors().map(vendor => vendor.id);
    }

    // 取消全選
    clearAll() {
        this.selectedVendors = [];
    }

    // 移除特定經紀
    removeVendor(vendorId: string) {
        this.selectedVendors = this.selectedVendors.filter(id => id !== vendorId);
    }

    // 取得已選擇的經紀詳細資訊
    getSelectedVendorDetails() {
        return this.selectedVendors.map(id =>
            this.vendor_list.find(vendor => vendor.id === id)
        ).filter(vendor => vendor);
    }

    // 產生帶有參數的 URL
    async getUrlWithParams(baseUrlProperty: string): Promise<void> {
        if (this.isProcessing) {
            alert('正在處理中，請稍候...');
            return;
        }

        if (this.selectedVendors.length === 0) {
            alert('請選擇至少一個廠商');
            return;
        }

        const baseUrl = (this as any)[baseUrlProperty];

        // 初始化進度
        this.isProcessing = true;
        this.totalProgress = this.selectedVendors.length;
        this.currentProgress = 0;
        this.startTime = Date.now(); // 記錄開始時間

        try {
            for (let i = 0; i < this.selectedVendors.length; i++) {
                const id = this.selectedVendors[i];
                this.currentProgress = i + 1;

                const uniqueTime = Date.now() + Math.floor(Math.random() * 1000);
                let url = baseUrl.replace("vid=-1", `vid=${id}`)
                                 .replace(/time=\d+/, `time=${uniqueTime}`);

                // type=5(合作經紀)的四張單改走 boss 匯出 API:
                //   勞務報酬單 → export_boss_member_info_2 / 勞務報酬單(領現) → export_boss_member_info_5
                //   會計匯款單 → export_boss_member_wd   / 領現單 → export_boss_member_wd_cash
                const vendor = this.vendor_list.find(v => v.id === id) as any;
                if (vendor && vendor['type'] == 5) {
                    if (baseUrlProperty === 'urltoken2') {
                        url = url.replace('export_vendor_info_2.php', 'export_boss_member_info_2.php');
                    } else if (baseUrlProperty === 'urltoken5') {
                        url = url.replace('export_vendor_info_5.php', 'export_boss_member_info_5.php');
                    } else if (baseUrlProperty === 'urltoken3') {
                        url = url.replace('export_vendor_info_3.php', 'export_boss_member_wd.php');
                    } else if (baseUrlProperty === 'urltoken6') {
                        url = url.replace('export_vendor_info_6.php', 'export_boss_member_wd_cash.php');
                    }
                }

                console.log(`正在處理第 ${this.currentProgress}/${this.totalProgress} 個廠商...`);

                window.open(url, '_blank');

                // 等待後再處理下一個（最後一個不用等）
                if (i < this.selectedVendors.length - 1) {
                    await this.delay(this.processingDelay);
                }
            }

            alert(`成功生成 ${this.selectedVendors.length} 個檔案！`);

        } catch (error) {
            console.error('處理錯誤:', error);
            alert('處理過程中發生錯誤');
        } finally {
            this.isProcessing = false;
            this.currentProgress = 0;
            this.totalProgress = 0;
            this.startTime = 0;
        }
    }




    // 延遲函數
    delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // 計算進度百分比
    getProgressPercent(): number {
        if (this.totalProgress === 0) return 0;
        return Math.round((this.currentProgress / this.totalProgress) * 100);
    }

    // 計算剩餘時間（秒）
    getRemainingTime(): number {
        const remaining = this.totalProgress - this.currentProgress;
        return Math.ceil((remaining * this.processingDelay) / 1000);
    }

    // 計算已用時間（秒）
    getElapsedTime(): number {
        if (this.startTime === 0) return 0;
        return Math.floor((Date.now() - this.startTime) / 1000);
    }

    // 格式化時間顯示（可選，更友好的時間顯示）
    formatTime(seconds: number): string {
        if (seconds < 60) {
            return `${seconds} 秒`;
        }
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes} 分 ${secs} 秒`;
    }

/////

    check_action(val){

        Swal.fire({
            title: "確定要更改提領月份?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "更改",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {
                this.save_withdrawal(val);
            }
        });

    }

    setMinAndMaxDates() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 月份從 0 開始，需要加 1

        // 當月第一天
        const firstDay = new Date(year, month - 1, 1);
        // 當月最後一天
        const lastDay = new Date(year, month, 0);

        this.minDate = this.formatDate(firstDay);
        this.maxDate = this.formatDate(lastDay);
    }

    formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    save_withdrawal(val){
        this.loading = true;
        const body = {id:val.id,actual_withdrawal_time:val.withdrawal_month,action:val.action,bank_account:val.bank_account,actual_withdrawal_status:val.actual_withdrawal_status};
        this.httpClient.post<any>("/set_user_ban_money.php",body).subscribe(res => {
            console.log('res',res)
            this.loading = false;
            if(res.status){
                Swal.fire({
                    title: '已儲存',
                    icon: "success"
                });
            }else{
                Swal.fire({
                    title: res.message,
                    icon: "error"
                });
            }
        });

    }

    handlePushMessageEmtSelected(item){
        this.loading = true;
        const body = {data:this.data,push:item,alls_user_id:this.alls_user_id};
        this.httpClient.post<any>("/once_push_message.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire({
                    title: '已送出',
                    icon: "success"
                });
            }
        });
    }



    calmoney(item){
        this.urlexporttoken = this.preurl+"/export_vendor_info_1.php?vid="+item.vid+"&token="+Dep.token+"&user_id="+item.user_id;
        this.loading = true;
        const body = {id:item.id};
        this.httpClient.post<any>("/payroll_recalculation.php",body).subscribe(res => {
            this.loading = false;
            console.log(res);
            if(res.status){
               this.cal_money_data = res.data;

                // 打開新窗口並導航到該 URL
                window.open(this.urlexporttoken, '_blank');

                Swal.fire({
                    text: "是否通知?",
                    icon: "success",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "確定",
                    cancelButtonText: "取消",
                }).then((result) => {
                    if (result.isConfirmed) {

                        this.notice_withdrawal(res.data);

                    }
                });

            }else{

                Swal.fire({
                    title: res.message,
                    icon: "error"
                });
            }
        });
    }

    notice_withdrawal(data){
        this.loading = true;
        const body = {data:JSON.stringify(data)};
        this.httpClient.post<any>("/notice_withdrawal.php",body).subscribe(res => {
            this.loading = false;

            if(res.status){

                Swal.fire({
                    title: '已通知',
                    icon: "success"
                });
            }
        });

    }




    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    del(type,idx){

        Swal.fire({
            text: "確定要刪除?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {
                if(type == 1){
                    console.log(this.diamond_data);
                    console.log(idx);
                    this.diamond_data.splice(idx, 1);
                }else{
                    this.money_data.splice(idx, 1);
                }
                Swal.fire({
                  title: "已刪除!",
                  icon: "success"
                });
            }
        });

    }


    handleRangeSelected( value: any ): void {

        let  eventDate = value.event;

        if(this.showDatePickersTatus){
            this.times.startDate = moment().subtract(7, 'days');
            this.times.endDate = moment().subtract(0, 'days');
            this.times.start = moment(this.times.startDate);
            this.times.end = moment(this.times.endDate);
        }else{
            this.times.startDate = '';
            this.times.endDate = '';
            this.times.start = '';
            this.times.end = '';
        }

        if(eventDate.startDate){
            this.times.start =  moment(eventDate.startDate).format('YYYY-MM-DD')
            this.times.end =  moment(eventDate.endDate).format('YYYY-MM-DD')
        }
        this.showDatePickersTatus = !this.showDatePickersTatus;
        this.init_list();
    }

    //判斷是否超出日期
    checkTime(){

        let start = new Date(this.edit_data.start_date);

        let nextMonth = start.getMonth() + 1;
        let year = start.getFullYear();

        // 如果下一个月是 12 月之后，则年份需要增加
        if (nextMonth > 11) {
            nextMonth = 0; // 1 月
            year += 1;
        }

        // 获取下个月 10 号的日期
        let nextMonth10th = new Date(year, nextMonth, 11);

        // 格式化日期为 YYYY-MM-DD
        let formattedDate = nextMonth10th.toISOString().split('T')[0];

        let today = new Date();

        // 格式化日期为 YYYY-MM-DD
        let todayformattedDate = today.toISOString().split('T')[0];

        //初始化
        this.outstatus = 0;

        if(todayformattedDate > formattedDate ){
            this.outstatus = 1;
        }
    }

    checkdata(){

        this.checkTime();

        this.diamondagenttextarea = '';
        this.moneyagenttextarea = '';

        this.loading = true;
        const body = {action:0,id:this.edit_data.id};
        this.httpClient.post<any>("/withdrawal_settings.php",body).subscribe(res => {
            if(res.status){
                this.loading = false;
                this.diamond_data = res.diamond_data;
                this.money_data = res.exchange_rate_data;
            }
        });
    }

    add_diamond(){

        //鑽石調整
        this.diamond_type = 1;
        this.diamond = '';
        this.diamod_month = '-2';
        this.diamondagenttextarea = '';

    }

    edit(item){

        //匯率調整
        this.diamond_type = 2;
        this.range_status = 1;
        if(item.val.all_diamond == 1){
            this.range_status = 0;
        }

        this.diamond = item.val.diamond;
        // this.diamod_type = item.val.exchange_rate;
        this.moneyagenttextarea = item.val.remark;

    }

    add_money(){

        //匯率調整
        this.diamond_type = 2;
        this.diamond = '';
        this.diamod_month = '-2';
    }

    checksave(type){

        if(type == 1){

            if(this.diamond == ''){
                Swal.fire("請輸入自訂鑽石數!", "", "error");
            }else if(this.diamod_month == '-2'){
                Swal.fire("請選擇調整月份!", "", "error");
            }else{

                let tmp = {'diamond':this.diamond,'month':this.diamod_month,'remark':this.diamondagenttextarea};
                this.diamond_data.push(tmp);
                this.diamond_type = 0;

            }
        }

        if(type == 2){
            if(this.diamond == '' && this.range_status == 1){
                Swal.fire("調整鑽石數必填!", "", "error");
            }else if(this.diamond > this.edit_data?.pre_cut_diamond && this.range_status == 1){
                Swal.fire("調整鑽石數不能超過加入前鑽石!", "", "error");
            }else{

                let tmpstatus = 0;
                if(this.range_status == 0){
                    this.diamond ='全部';
                    tmpstatus = 1;
                }

                let tmp ={'all_diamond':tmpstatus,'diamond':this.diamond,'exchange_rate':this.diamod_type,'month':this.diamod_month,'remark':this.moneyagenttextarea};

                this.money_data = [tmp];
                this.diamond_type = 0;

            }
        }
    }

    checkcancel(){
        this.diamond_type = 0;
    }

    saverange(){
        this.loading = true;
        const body = {exchange_rate_data:JSON.stringify(this.money_data), diamond_data:JSON.stringify(this.diamond_data),action:1,id:this.edit_data.id};
        this.httpClient.post<any>("/withdrawal_settings.php",body).subscribe(res => {
            if(res.status){
                this.loading = false;
                Swal.fire("已儲存", "", "success");
            }
        });

    }


    sub_choose(now:string):void{
        this.sublist_now = now;
        let tmp_data = {};
        if(now=='0'){
            Rtable.structure.type = 'num';
            tmp_data = {
                rank:{name:'名次',type:'txt'},
                name:{name:'會員名',type:'opt'},
                profile_pic:{name:'大頭',type:'img',type_cls_dk:'width50px'},
                text_income:{name:'文字收益',unit:'鑽',sort:1},
                voice_income:{name:'語音收益',unit:'鑽',sort:1},
                video_income:{name:'視訊收益',unit:'鑽',sort:1},
                album_income:{name:'解鎖收益',unit:'鑽',sort:1},
                game_income:{name:'遊戲收益',unit:'鑽',sort:1},
                active_reward:{name:'活動收益',unit:'鑽',sort:1},
                gift_reward:{name:'禮物收益',unit:'鑽',sort:1},
                donate_income:{name:'抖內收益',unit:'鑽',sort:1},
                voice_room_income:{name:'語聊房收益',unit:'鑽',sort:1},
                other:{name:'其他收益',unit:'鑽',sort:1},
                all:{name:'總收益',unit:'鑽',sort:1},
            }
            this.sort_obj = {column:'all',sort:'0'}
            this.posts_attributes = Rtable.init(tmp_data);
            this.init_time();
            return; // init_time() 內 500ms 後會打 init_list，結尾那支不再重打（原本重複兩次）
        }else if(now=='9'){
            Rtable.structure.type = 'num';
            tmp_data = {
                rank:{name:'名次',type:'txt'},
                name:{name:'會員名',type:'opt'},
                profile_pic:{name:'大頭',type:'img',type_cls_dk:'width50px'},
                text_income:{name:'文字收益',unit:'鑽',sort:1},
                voice_income:{name:'語音收益',unit:'鑽',sort:1},
                video_income:{name:'視訊收益',unit:'鑽',sort:1},
                album_income:{name:'解鎖收益',unit:'鑽',sort:1},
                game_income:{name:'遊戲收益',unit:'鑽',sort:1},
                active_reward:{name:'活動收益',unit:'鑽',sort:1},
                gift_reward:{name:'禮物收益',unit:'鑽',sort:1},
                donate_income:{name:'抖內收益',unit:'鑽',sort:1},
                voice_room_income:{name:'語聊房收益',unit:'鑽',sort:1},
                other:{name:'其他收益',unit:'鑽',sort:1},
                all:{name:'總收益',unit:'鑽',sort:1},
            }
            this.sort_obj = {column:'all',sort:'0'}
            this.posts_attributes = Rtable.init(tmp_data);
            this.init_time();
            return; // 同上，init_time() 已排程 init_list
        }else{
            Rtable.structure.type = 'txt';
            tmp_data = {
                name:{name:'會員名',type:'opt'},
                profile_pic:{name:'大頭',type:'img',type_cls_dk:'width50px'},
                login_time:{name:'在線時間',sort:1},
                text_num:{name:'訊息數(送)',sort:1},
                get_text_num:{name:'訊息數(收)',sort:1},
                voice_time:{name:'語音時間',sort:1},
                video_time:{name:'視訊時間',sort:1},
                game_time:{name:'遊戲時間',sort:1},
                story_num:{name:'動態數',sort:1},
            }
            this.sort_obj = {column:'login_time',sort:'0'}
            this.posts_attributes = Rtable.init(tmp_data);
        }
        this.init_list();
    }

    trackByFn(i: number, item: any): any { return item ? (item.id ?? item.user_id ?? i) : i; }

    ngOnInit(): void {


        // 獲取當前日期
        let today = new Date();

        // 獲取今天的日期
        this.dayOfMonth = today.getDate();

        this.config();
        this.dateTime();

        this.preurl = environment.serverurl;

        this.serverExcelurl = environment.serverExcelurl;


        if(this.route.snapshot.paramMap.get('vid')){
            this.vid = this.route.snapshot.paramMap.get('vid');
        }
        if(this.route.snapshot.paramMap.get('mid')){
            this.now = this.route.snapshot.paramMap.get('mid');
        }

        this.choose(this.now);

        let now = new Date();

        let year = now.getFullYear();

        let month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份加1，并转换为两位数

        this.nowMonth = year+'-'+month;


        this.serial_init();
        this.load_birthday_members();
        this.checkDeviceType();
        window.addEventListener('resize', this.boundResizeHandler);
    }

    dateTime() {
        // 获取当前日期
        const currentDate = new Date();
        // 获取当前年份、月份和日期
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() 返回 0-11，需要加 1
        const currentDay = currentDate.getDate();

        // 计算上一个月份的年份和月份
        let prevYear = currentYear;
        let prevMonth = currentMonth - 1;

        if (prevMonth < 1) {
            prevMonth = 12;
            prevYear -= 1;
        }

        // 计算下一个月份的年份和月份
        let nextYear = currentYear;
        let nextMonth = currentMonth + 1;

        if (nextMonth > 12) {
            nextMonth = 1;
            nextYear += 1;
        }

        // 格式化月份为两位数
        const formatMonth = (month) => month.toString().padStart(2, '0');

        // 格式化上个月、当前月份和下一个月份
        const formattedPrevMonth = `${prevYear}-${formatMonth(prevMonth)}`;
        const formattedCurrentMonth = `${currentYear}-${formatMonth(currentMonth)}`;
        const formattedNextMonth = `${nextYear}-${formatMonth(nextMonth)}`;

        // 根据当前日期调整要显示的月份列表
        if (currentDay < 10) {
            this.diamod_month_list = [
                {id: formattedPrevMonth, name: formattedPrevMonth},
                {id: formattedCurrentMonth, name: formattedCurrentMonth},
            ];
        } else if (currentDay === 10) {
            this.diamod_month_list = [
                {id: formattedPrevMonth, name: formattedPrevMonth},
                {id: formattedCurrentMonth, name: formattedCurrentMonth},
                {id: formattedNextMonth, name: formattedNextMonth},
            ];
        } else {
            this.diamod_month_list = [
                {id: formattedCurrentMonth, name: formattedCurrentMonth},
                {id: formattedNextMonth, name: formattedNextMonth},
            ];
        }
    }

    config(){
        const body = {token:Dep.token,gettime:1};
        this.httpClient.post<any>("/get_withdrawal_config.php",body).subscribe(res => {
            if(res.status){
                this.selectedDateTime = res.des[0];
                this.withdrawal_changes = res.des[1];
            }
        });
    }

    init_time(){
        if(this.default_time){
            this.time.startDate = moment().subtract(7, 'days');
            this.time.endDate = moment().subtract(0, 'days');
            this.time.start = moment().subtract(7, 'days').format('YYYY-MM-DD')
            this.time.end = moment().subtract(0, 'days').format('YYYY-MM-DD')
            this.time.minDate = moment().subtract(40, 'days')
            this.time.maxDate = moment().subtract(0, 'days')
        }
        window.setTimeout(()=>{
            this.init_list();
        },500)
    }

    handleClick( value: any ,type: any): void {
        this.detailnember_type = -1;
        this.detailnemberstatus = 0;
        this.pageobj3 = {page:0,count:20,total_count:0};
        this.pageobjstr3 = JSON.parse(JSON.stringify(this.pageobj3));
        this.detailstatus = 1;
        this.detail_type = type;
        this.key = value.key;
        this.modalService.open(this.yourModalContent, { centered: true,size: 'lg' });
        this.init_detail_list();
    }

    handleClick2( value: any ,type: any): void {
        this.detail_type = -1;
        this.pageobj3 = {page:0,count:20,total_count:0};
        this.pageobjstr3 = JSON.parse(JSON.stringify(this.pageobj3));
        this.detailstatus = 0;
        this.detailnemberstatus = 1;
        this.detailnember_type = type;
        this.key = value;
        this.modalService.open(this.yourModalContent2, { centered: true,size: 'lg' });
        this.init_detail_list();
    }

    createlink(item){
        this.urltoken8 = this.preurl+"/export_profilelist.php?id="+item.user_id+"&token="+Dep.token+"&time="+Date.now();
        this.copyToClipboard(this.urltoken8);
    }

    copyToClipboard(item) {
        var clipBoardElem = document.createElement("input");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = item;
        clipBoardElem.select();
        var successfulCopy = document.execCommand('copy');
        alert('複製成功');
        document.body.removeChild(clipBoardElem)
    }

    view_each_round(item){
        this.fuck_item = item;
        this.subnow = '4';
        this.loading = true;
        const body = {
            page: this.pageobj2.page,count:this.pageobj2.count,
            type:2,
            vid:this.vid,
            search_model:item.user_id,
            enable_type:this.enable_type,
            vtype:this.vtype
        };
        this.httpClient.post<any>("/get_vendor_member.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.round_info = res.round_info;
                this.edit_data = res.data;
                this.pageobj2.total_count = res.total_count;
            }else{
                this.edit_data = [];
                this.round_info = [];
                this.pageobj2.total_count = 0;
            }
            this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
        });
    }

    init_detail_list(){
        this.loading = true;
        const body = {
            detailpage: this.pageobj3.page,detailcount:this.pageobj3.count,
            type:this.now,
            vid:this.vid,
            key:this.key,
            detailstatus:this.detailstatus,
            detailnemberstatus:this.detailnemberstatus,
            detail_type:this.detail_type,
            detailnember_type:this.detailnember_type,
            nowMonth:this.nowMonth,
            enable_type:this.enable_type,
            vtype:this.vtype
        };

        this.httpClient.post<any>("/get_vendor_member.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                if(this.now == '6'){

                    this.serizedetaildata = res.datailserizedata;

                    if(this.detail_type == 1){

                        this.tcontent1 = [
                            {title:'名稱',content:'name',type:2},
                            {title:'時間(小時)',content:'login_times_front',type:3},
                        ];

                    }else if(this.detail_type == 2){

                        this.tcontent1 = [
                            {title:'名稱',content:'name',type:2},
                            {title:'最後登錄時間',content:'last_singin_date',type:3},
                        ];

                    }

                    if(this.detailnember_type > 0){

                        let envSerize = [
                            'total_income','null','text_income','voice_income',
                            'video_income','album_income','game_income',
                            'active_reward','gift_reward','live_reward',
                            'date_reward','voice_room_income','donate_income',
                            'ticket_income','interactive_income',
                            'other'
                        ];

                        let tmpkey = this.key;

                        this.tcontent1 = [
                            {title:'名稱',content:'name',type:2},
                            {title:this.serizedata3[this.key].sourcetime,content:envSerize[tmpkey],type:0},
                        ];



                    }

                }
                this.pageobj3.total_count = res.detailtotal_count;
                this.pageobjstr3 = JSON.parse(JSON.stringify(this.pageobj3));

            }

        });
    }

    rank_list(){

        this.loading = true;
        this.pageobj.count = 12;

        const body = {
            page: this.pageobj.page,count:this.pageobj.count,
            sort_obj:this.sort_obj,
            type:this.now,
            vid:this.vid,
            ranklist:this.rank_announce_select,
            vtype:this.vtype
        };

        this.httpClient.post<any>("/get_vendor_member_rank.php",body).subscribe(res => {
            this.loading = false;
            this.rank_data = res.data;
            this.pageobj.total_count = res.total_count;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))

        });

    }

    check_list_init_list(){
        if(this.vtype != 2){
            this.vid = '-1';
        }
        this.check_init_list();
    }


    check_init_list(){

        this.now_vinfo = '';

        this.status_man = false;
        if(this.vid != '-1'){
            this.status_man = true;
        }

        if(this.now == '8'){
            this.rank_list();
        }else{
            this.init_list();
        }

        this.load_birthday_members();

        if(this.vid != '-1'){

            const power_id = Dep.user.powers.power_id;

            if(power_id == '5' || power_id == '6' || power_id == '13'){
                this.menu_list = [
                    {id:'6',name:'每日統計'},
                    {id:'8',name:'經紀人員活動排名狀況'},
                    {id:'0',name:'人員列表'},
                    {id:'4',name:'提領對帳表'},
                    {id:'5',name:'人員狀態'},
                    {id:'11',name:'人員新增'},
                ];
            }else{
                this.menu_list = [
                    {id:'6',name:'每日統計'},
                    {id:'8',name:'經紀人員活動排名狀況'},
                    {id:'0',name:'人員列表'},
                    {id:'4',name:'提領對帳表'},
                    {id:'5',name:'人員狀態'},
                ];
            }


            if(this.now == '10'){
                this.now = '6';
            }

        }else{

            this.menu_list = [
                {id:'6',name:'每日統計'},
                {id:'8',name:'經紀人員活動排名狀況'},
                {id:'0',name:'人員列表'},
                {id:'4',name:'提領對帳表'},
                {id:'5',name:'人員狀態'},
                // {id:'10',name:'停權提領'},
            ];
        }
    }

    getYearStartDates() {
        let currentDate = new Date(); // 获取当前日期
        currentDate.setMonth(currentDate.getMonth() - 1); // 往前一个月
        let monthDates = [];

        for (let i = 0; i < 12; i++) {
            let year = currentDate.getFullYear(); // 获取年份
            let month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 确保月份是两位数

            // 格式化为 YYYY-MM 的字符串
            let date = { id: `${year}-${month}`, name: `${year}年${month}月` };
            monthDates.push(date);

            // 移动到下一个月
            currentDate.setMonth(currentDate.getMonth() + 1);
        }

        return monthDates;
    }


    getMonthStartDates() {
        const year = new Date().getFullYear(); // 获取当前年份
        let monthDates = [];

        for (let i = 1; i <= 12; i++) {
            // 格式化为 YYYY-MM-01 的字符串
            let month = i.toString().padStart(2, '0'); // 确保月份是两位数
            let date = {id:`${year}-${month}-01`,name:`${month}月01號`};
            monthDates.push(date);
        }

        return monthDates;
    }


    isYearSelectable(withdrawalYear: string): boolean {
        let lastMonth = this.getPreviousMonth();
        let withdrawalYearNum = parseInt(withdrawalYear?.replace('-', ''));
        let lastMonthNum = parseInt(lastMonth.replace('-', ''));
        if(withdrawalYearNum >= lastMonthNum){
            return true;
        }

        return false;
    }


    getPreviousMonth() {
        let date = new Date(); // 獲取當前日期

        // 設置月份到上一個月
        date.setMonth(date.getMonth() - 1);

        // 格式化年和月
        let previousYear = date.getFullYear();
        let previousMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // 確保月份是兩位數

        return `${previousYear}-${previousMonth}`;
    }

    init_list(){
        if(this.now == '10'){
            let monthStartDates = this.getYearStartDates();
            this.withdrawal_month_option = monthStartDates;

            //    // 獲取當前年份和月份
            // this.thismonth = new Date().getMonth() + 1; // getMonth() 返回值為 0-11，所以加1

            // // 過濾掉低於當前月份的選項
            // this.withdrawal_month_option = this.withdrawal_month_option.filter(option => {
            //     const optionMonth = parseInt(option.id.split('-')[1]); // 假設 option.id 的格式是 YYYY-MM
            //     return optionMonth > this.thismonth;
            // });



            this.loading = true;
            const body = {
                page: this.pageobj.page,count:this.pageobj.count,
                type:this.now,
                vid:this.vid,
                search_txt:this.search_model
                // sort_obj:this.sort_obj,
            };
            this.httpClient.post<any>("/get_user_ban_money.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    this.data = res.data;
                    this.pageobj.total_count = res.total_count;
                    this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))

                }

            });

        }else{

            this.loading = true;
            if(this.now=='4' || this.now=='5'){
                this.pageobj.count = 12;
                this.pageobj3.count = 12;
            }else{
                this.pageobj.count = 12;
            }


            if(this.now=='4'){
                let monthStartDates = this.getYearStartDates();
                this.withdrawal_month_option = monthStartDates;
            }

            const body = {
                page: this.pageobj.page,count:this.pageobj.count,
                detailpage: this.pageobj3.page,detailcount:this.pageobj3.count,
                type:this.now,
                vid:this.vid,
                sort_obj:this.sort_obj,
                time:this.time,
                search_model:this.search_model,
                sub_type:this.sublist_now,
                month:this.current_month,
                monthEnd:this.current_monthed,
                search_lv:this.search_lv,
                search_status:this.search_status,
                search_trasnfer_status:this.search_trasnfer_status,
                search_health_fee:this.search_health_fee,
                search_account_memo:this.search_account_memo,
                search_withdrawal_status:this.search_withdrawal_status,
                search_offline_day:this.search_offline_day,
                key:this.key,
                nowMonth:this.nowMonth,
                times:this.times,
                enable_type:this.enable_type,
                vtype:this.vtype,
                DailyEmpNumSearchDay:this.selectedDays,
            };
            console.log("body: " + JSON.stringify(body));
            this.httpClient.post<any>("/get_vendor_member.php",body).subscribe(res => {
                this.loading = false;
                if(this.sublist_now=='0' && this.now=='3'){
                    this.now_vinfo = res.now_vinfo;
                }

                if(res.status){
                    console.log("res: " + JSON.stringify(res));

                    this.rank_announce_list = res.aDataRank;

                    if(this.now == '6'){

                        this.now_vinfo = res.now_vinfo;

                        this.tcontent = [
                            {title:'時間',content:'sourcetime'},
                            {title:'人數',content:'sourcecount',type:3},
                        ];

                        this.tcontent1x = [
                            {title:'時間',content:'linetime'},
                            {title:'人數',content:'lineount',type:3},
                        ];

                        this.all_nember = res.all_nember;
                        this.vendor_update_time = res.vendor_update_time;

                        const series = [
                            {
                                name: "百分比",
                                colorByPoint:true,
                                data:res.pieOptions,
                            }
                        ];

                        const series2 = [
                            {
                                name: "百分比",
                                colorByPoint:true,
                                data:res.pieOptions2,
                            }
                        ];


                        this.pieOptions.series = series;
                        this.pieOptions.title.text = '人員上線比例圖';

                        this.pieOptions2.series = series2;
                        this.pieOptions2.title.text = '人員未上線比例圖';

                        this.serizedata = res.serizedata;

                        if(this.serizedata.length > 0){

                            this.serizedataTotal = 0;

                            this.serizedata.forEach(element => {
                                this.serizedataTotal = this.serizedataTotal + Number(element.sourcecount);
                            });

                        }

                        this.serizedata2 = res.serizedata2;

                        this.serizedata3 = res.serizedata3;


                        this.tcontent2= [
                            {title:'收入來源',content:'sourcetime'},
                            {title:'金額',content:'sourcecount',type:3},
                        ];


                        const series3 = [
                            {
                                name: "百分比",
                                colorByPoint:true,
                                data:res.pieOptions3,
                            }
                        ];

                        this.pieOptions3.series = series3;
                        this.pieOptions3.title.text = '經紀收入來源比例圖';
                        this.serizedata4 = res.serizedata4;


                        this.tcontent2x = [
                            {title:'收入來源',content:'sourcetime'},
                            {title:'金額',content:'sourcecount',type:3},
                        ];


                        const series2x = [
                            {
                                name: "百分比",
                                colorByPoint:true,
                                data:res.pieOptions4,
                            }
                        ];

                        this.pieOptions4.series = series2x;
                        this.pieOptions4.title.text = this.nowMonth+'經紀收入來源比例圖';

                        this.serizedat3total = res.serizedata3total;
                        this.serizedata4total = res.serizedata4total;

                        this.updateFlag = true;

                        if(res.aAllCount != 0){
                            this.total = res.aAllCount;
                        }

                    }

                    this.data = res.data;
                    this.active_info = res.active_info;

                    this.vendor_list = res.vendor_list;

                    if(this.vendor_list.length == 1){
                        this.vid = this.vendor_list[0].id;
                    }

                    this.all_vendor_list = res.all_vendor_list;
                    this.pageobj.total_count = res.total_count;
                    this.daily_income = res.daily_income;
                    this.numBan = res.numBan;
                    this.alls_user_id = res.alls_user_id;

                    // console.log("all_vendor_list: " + JSON.stringify(this.all_vendor_list));

                    if(res.vendorTargetHistory != 0){
                        this.historySettingContent = res.vendorTargetHistory; // 這裡將歷史設定數值傳遞
                    } else{
                        this.historySettingContent = [];
                    }
                    this.vendorDailySummary = res.vendorDailySummary; // 這裡將每日群發、精選動態等現有值傳遞

                    this.all_vendor_list.forEach(element => {
                        let vendorId = element.id; // 取得 vendor_list_id

                        // 從 vendorDailySummary 中查找對應的數據
                        let summaryData = this.vendorDailySummary[vendorId];

                        // **手動添加屬性**
                        element["mass_sending_count"] = summaryData ? summaryData.mass_sending_count : 0;
                        element["featured_post_count"] = summaryData ? summaryData.featured_post_count : 0;
                        element["total_income"] = summaryData ? summaryData.total_income : 0;
                        element["recruitment_count"] = summaryData ? summaryData.recruitment_count : 0;

                        element["daily_mass_message_target"] = element["daily_mass_message_target"] ? parseInt(element["daily_mass_message_target"]) : 0;
                        element["featured_post_target"] = element["featured_post_target"] ? parseInt(element["featured_post_target"]) : 0;
                        element["monthly_target"] = element["monthly_target"] ? parseInt(element["monthly_target"]) : 0;
                        element["recruitment_target"] = element["recruitment_target"] ? parseInt(element["recruitment_target"]) : 0;
                    });

                    this.processVendorData(res.vendorDailyEmpNum);

                    // if(this.vid=='-1' && res.data.length>0){
                    //   this.vid = res.data[0].vid;
                    // }else if(this.vid=='-1' && res.data.length==0){
                    //   this.vid = res.vendor_list[0].id
                    // }
                    if(this.now=='4'){
                        this.data.forEach(element => {
                            element.memo = JSON.parse(element.memo);
                        });
                    }

                    // if(this.now == '9'){
                    //     if(res.aAllCount != 0){
                    //         this.total = res.aAllCount;
                    //     }
                    // }

                    if(this.now=='11'){

                        this.tcontent = [
                            {title:'經紀名稱',content:'vendor_name'},
                            {title:'邀請用戶',content:'name',type:2},
                            {title:'申請者',content:'ename'},
                            {title:'狀態',content:'status',type:3},
                            {title:'建立時間',content:'create_dt'},
                            {title:'更新時間',content:'update_dt'},
                            {title:'操作',content:'gg',type:3},
                        ];

                    }


                }else{
                    this.pageobj.total_count = 0
                    this.data = [];
                    this.vendor_list = [];
                }
                this.posts_input = {
                    attribute:this.posts_attributes,
                    content:this.data,
                    sort_obj:this.sort_obj,//clone一份避免被rtable改掉
                }
                this.urltoken = this.preurl+"/export_vendor_info.php?limit=true&vid="+this.vid+"&token="+Dep.token+"&time="+Date.now();
                this.urltoken2 = this.preurl+"/export_vendor_info_2.php?limit=true&vid="+this.vid+"&token="+Dep.token+"&time="+Date.now();
                this.urltoken3 = this.preurl+"/export_vendor_info_3.php?limit=true&vid="+this.vid+"&token="+Dep.token+"&time="+Date.now();
                this.urltoken5 = this.preurl+"/export_vendor_info_5.php?limit=true&vid="+this.vid+"&token="+Dep.token+"&time="+Date.now();
                this.urltoken6 = this.preurl+"/export_vendor_info_6.php?limit=true&vid="+this.vid+"&token="+Dep.token+"&time="+Date.now();
                this.urltoken4 = this.serverExcelurl+"/export_vendor_info_4.php?limit=true&token="+Dep.token+"&time="+Date.now();
                this.urltoken7 = this.preurl+"/export_vendor_info_7.php?limit=true&token="+Dep.token+"&time="+Date.now();
                this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
                //this.init_bank_statement_list(this.vid, Dep.token);
            });
        }
    }

    processVendorData(data: any[]): void {
        let dailyData = Array.isArray(data[0]) ? data[0] : []; // 確保 dailyData 為陣列
        const vendorList = Array.isArray(data[1]) ? data[1] : [];
        const vendorListCount = data[1].length;

        // **建立經紀商 ID 與名稱對應關係**
        this.vendorNames = {};
        vendorList.forEach(v => {
            this.vendorNames[v.id] = v.vendor_name;
        });

        // **取得所有日期，確保 X 軸統一**
        let uniqueDates: string[] = [...new Set(dailyData.map(d => String(d.date)))];
        uniqueDates.sort();

        // **整理經紀商的數據**
        const vendorSeries: Record<string, Highcharts.SeriesLineOptions> = {};

        dailyData.forEach(d => {
            const vid = d.vid;

            // **確保該經紀商有對應的 `series`**
            if (!vendorSeries[vid]) {
                vendorSeries[vid] = {
                    name: this.vendorNames[vid] || `單位 ${vid}`,
                    type: 'line',
                    data: Array(uniqueDates.length).fill(null) // 預設填充 null 避免遺漏
                };
            }

            // **確保日期對應的 index 正確**
            const index = uniqueDates.indexOf(d.date);
            if (index !== -1) {
                vendorSeries[vid].data[index] = Number(d.emp_num);
            }
        });

        // **確保 `seriesData` 至少有 4 條數據**
        let seriesData: Highcharts.SeriesOptionsType[] = Object.values(vendorSeries);

        console.log("✅ 檢查 `seriesData.length`：", seriesData.length, seriesData);

        // **處理無數據的情況**
        if (seriesData.length === 0 || uniqueDates.length === 0) {
            console.warn("⚠️ 無數據，插入 `無數據` 假數據！");
            seriesData = [{
                name: vendorList[0].vendor_name,
                type: "line",
                data: Array(uniqueDates.length || 1).fill(0) // 確保至少顯示一條線
            }];
            uniqueDates = [new Date().toISOString().split("T")[0]]; // 塞入今天的日期
        } else {
            // **移除舊的 `無數據` 但保留真實數據**
            seriesData = seriesData.filter(s => s.name !== "無數據");
        }

        // **確保如果 `seriesData` 只有 1 條數據時，仍保留所有經紀商數據**
        if (seriesData.length < vendorListCount) {
            console.warn("⚠️ 經紀商數據不足，補充預設數據！");
            for (let i = seriesData.length; i < vendorListCount; i++) {
                seriesData.push({
                    name: vendorList[i].vendor_name,
                    type: "line",
                    data: Array(uniqueDates.length).fill(0)
                });
            }
        }

        // **最終更新 Highcharts**
        console.log("📊 更新 Highcharts 設定：", seriesData);
        this.vendorEmpNumlineOptions = {
            ...this.vendorEmpNumlineOptions,
            xAxis: { categories: uniqueDates },
            series: seriesData as Highcharts.SeriesOptionsType[] // 確保型別正確
        };

        // **觸發 Highcharts 更新**
        this.vendorEmpNumUpdateFlag = true;
    }

    setTime(act){
        let body = {};
        if(act == 1){
            body = {token:Dep.token,data:this.selectedDateTime, setitme:1};
            this.httpClient.post<any>("/set_withdrawal_config.php",body).subscribe(res => {
                if(res.status){
                    Swal.fire("已設定完成!", "", "success");
                }
            });
        }else{
            Swal.fire({
                title: "確定要更改提領異動狀態?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "更改",
                cancelButtonText: "取消",
            }).then((result) => {
                if (result.isConfirmed) {
                    // 更新狀態邏輯
                    this.withdrawal_changes_to = this.getNextWithdrawalStatus(this.withdrawal_changes);

                    const body = {
                        token: Dep.token,
                        data: this.withdrawal_changes_to,
                        payout: 1
                    };

                    this.httpClient.post<any>("/set_withdrawal_config.php", body).subscribe(
                        res => {
                            if (res.status) {
                                Swal.fire("已設定完成!", "", "success");
                                this.config();
                            } else {
                                Swal.fire("設定失敗!", "", "error");
                            }
                        },
                        error => {
                            Swal.fire("發生錯誤!", "請稍後再試。", "error");
                            console.error('API Error:', error);
                        }
                    );
                }
            });
        }
    }

    // 獲取下一個提領狀態的方法
    getNextWithdrawalStatus(currentStatus: string): string {
        switch (currentStatus) {
            case '0':
                return '1';
            case '1':
                return '2';
            default:
                return currentStatus;
        }
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            if(this.now == '8'){
                this.rank_list();
            }else{
                this.init_list();
            }
        }
    }

    callback2(pageobj:page){
        if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
            this.pageobj2 = pageobj;
            this.view_each_round(this.fuck_item);
        }
    }

    callback3(pageobj:page){
        if(JSON.stringify(this.pageobj3)!=JSON.stringify(pageobj)){
            this.pageobj3 = pageobj;
            this.init_detail_list();
        }
    }

    historySettingCallBack(historySettingPageObj:page){
        if(JSON.stringify(this.historySettingPageObj)!=JSON.stringify(historySettingPageObj)){
          this.historySettingPageObj = historySettingPageObj;
          this.init_list();
        }
      }


    all_edit(){
        this.subnow = '3';
        this.edit_data={
            id:-2,
            method_type:3,
            salary_type:2,
            bonus_type:1,
            pre_recount_status:0,is_hidden:0
        }
    }

    serial_callback(pageobj:page){
        if(JSON.stringify(this.serial_pageobj)!=JSON.stringify(pageobj)){
            this.serial_pageobj = pageobj;
            this.cfd_serial();
        }
    }

    serial_edit(data){
        this.edit_serial_data = data;
        this.subnow='6';
    }

    serial_remove(data){
        if(confirm('確定要刪除 '+data.serial+' ?')){
            const body = {token:Dep.token, data, remove:1};
            this.httpClient.post<any>("/set_user_serial.php",body).subscribe(res => {
                if(res.status){
                    alert('刪除成功');
                }else{
                    alert(res.message);
                }
                 this.cfd_serial();
            });
        }
    }

    serial_add(){
        this.edit_serial_data = {
            serial:'',
            name:'',
            id_no:'',
            addr:'',
        };
        this.subnow='6';
    }

    serial_save(){
        const body = {token:Dep.token, data:this.edit_serial_data};
        if(this.edit_serial_data.name == ''){
            alert('姓名未填');
            return;
        }
        this.httpClient.post<any>("/set_user_serial.php",body).subscribe(res => {
            if(res.status){
                alert('儲存成功');
            }else{
                alert(res.message);
            }
            this.cfd_serial();
        });
        this.subnow='5';
    }

    serial_init(){
        Rtable.structure.type = 'txt';
        let tmp_data = {
            serial:{name:'序號'},
            name:{name:'會員'},
            id_no:{name:'身分證'},
            addr:{name:'戶籍'},
            memo:{name:'備註',},
            phone_num:{name:'手機號碼',},
            // opt:{name:'修改', type:'opt'},
        }
        this.serial_attributes = Rtable.init(tmp_data);
    }

    cfd_serial(){
        this.subnow = '5';
        const body = {token:Dep.token, page: this.serial_pageobj.page, count:this.serial_pageobj.count, search_txt:this.search_serial};
        this.httpClient.post<any>("/get_user_serial.php",body).subscribe(res => {
            if(res.status){
                this.serial_data = res.data;
                this.serial_input = {
                    attribute:this.serial_attributes,
                    content:res.data,
                    sort_obj:{column:'serial',sort:'0'},
                }
                this.serial_pageobj.total_count = res.total_count;;
                this.serial_pageobjstr=JSON.parse(JSON.stringify(this.serial_pageobj))
            }else{
                alert(res.message);
            }
        });
    }

    view_round(item,type){
        this.subnow='2';
        this.edit_data = item.this_round;
        this.subnow_menu_data = item.this_round.menu;
        if(type==2){
            this.edit_data = item.last_round;
            this.subnow_menu_data = item.last_round.menu;
        }
    }

    save(){
        let status = true;
        if(this.edit_data.status==-1){
            status = false;
            if(confirm('是否確定要解除!?短時間內將無法再變為合作關係')){
                status  = true;
            }
        }
        if(this.edit_data.lv == ''){
            status = false;
            alert("請填寫等級");
        }
        // 切成工作室一定要有名稱，工作室對帳頁與匯出都靠它辨識
        if(this.edit_data.is_studio == '1' && !(this.edit_data.studio_name || '').trim()){
            status = false;
            alert("請填寫工作室名稱");
        }
        if(status){
            this.loading = true;
            const body = {data:this.edit_data,type:4,vid:this.vid};
            this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    this.init_list();
                }else{
                    alert(res.message);
                }
            });
        }
    }

    save_set(){

        if (this.edit_profile.id_name == '') {
            Swal.fire({
                title: '姓名為必填',
                icon: "error"
            });
            return;
        }

        if (this.edit_profile.id_number == '') {
            Swal.fire({
                title: '身分證字號為必填',
                icon: "error"
            });
            return;
        }

        if (this.edit_profile.permanent_addr == '') {
            Swal.fire({
                title: '戶籍地址為必填',
                icon: "error"
            });
            return;
        }

        if (this.edit_profile.id_card == '') {
            Swal.fire({
                title: '身分證正面必上傳',
                icon: "error"
            });
            return;
        }


        if (this.edit_profile.id_cardback == '') {
            Swal.fire({
                title: '身分證背面必上傳',
                icon: "error"
            });
            return;
        }

        this.loading = true;
        const body = {user_id:this.set_profile.user_id,type:1,edit_profile:this.edit_profile};
        this.httpClient.post<any>("/get_real_personal.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                Swal.fire({
                    title: '已修改',
                    icon: "success"
                });

            }
        });

    }

    edit_pro(item){
        this.set_profile = item;
        this.loading = true;
        const body = {user_id:item.user_id,type:0};
        this.httpClient.post<any>("/get_real_personal.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                if(res.data.length  == 0){
                    this.edit_profile = {id_number:'',id_name:'',permanent_addr:'',id_card:'',id_cardback:'',healthy_fee_cn:0,memo:''};
                }else{
                    this.edit_profile = res.data[0];
                }
            }
        });

        this.modalService.open(this.yourModalContent3, { centered: true,size: 'lg' });

    }
    upload(event: any) {
        var that = this;
        that.loading = true;
        let body :FormData = new FormData();
        const send_url = environment.serverurl + "/import_actual_withdrawal_status_excel.php";
        const xhr = new XMLHttpRequest();
        body.append("token",Dep.token);
        body.append("file[]",event.target.files[0]);
        xhr.open("POST", send_url, true);
        xhr.onloadend=function(){
            var res = JSON.parse(this.response)
            that.loading = false;
            if(res.status){

                Swal.fire({
                    title: '上傳成功',
                    icon: "success"
                });

            }
        }
        xhr.send(body);
    }

    handleImageUpload(file: File,type:Number): void {

        if(type == 0){
            this.edit_profile.id_card = file;
        }else{
            this.edit_profile.id_cardback =file;
        }

    }

    add_user(){
        this.loading = true;
        const body = {data:this.edit_data,type:3,vid:this.vid};
        this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.now = '0';
                this.init_list();
            }else{
                alert(res.message);
            }
        });
    }

    ck_phone(){
        this.loading = true;
        const body = {data:this.edit_data,type:2};
        this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.edit_data.name = res.data.name
                this.edit_data.profile_pic = res.data.profile_pic
            }else{
                this.edit_data.name = ''
                this.edit_data.profile_pic = ''
                alert('查無此人');
            }
        });
    }

    load_birthday_members() {
        this.birthday_loading = true;
        const body: any = {
            date_start: this.bd_income_start,
            date_end: this.bd_income_end,
            birthday_start: this.bd_date_start,
            birthday_end: this.bd_date_end,
        };
        if (this.vid && this.vid !== '-1') {
            body.vid = this.vid;
        }
        this.httpClient.post<any>('/comm/get_community_birthday_members.php', body).subscribe({
            next: (res: any) => {
                this.birthday_loading = false;
                if (res?.status && res.data) {
                    const list = res.data.list || [];
                    list.forEach((b: any) => { b.reward_status = parseInt(b.reward_status, 10) || 0; });
                    this.birthday_list_raw = list;
                    this.birthday_count = res.data.count || 0;
                    this.birthday_week = (res.data.birthday_start || '') + ' ~ ' + (res.data.birthday_end || '');
                }
            },
            error: () => { this.birthday_loading = false; }
        });
    }

    bd_handleRangeSelected(event: any) {
        const e = event.event;
        if (e && e.startDate && e.endDate) {
            this.bd_income_start = moment(e.startDate).format('YYYY-MM-DD');
            this.bd_income_end = moment(e.endDate).format('YYYY-MM-DD');
            this.load_birthday_members();
        }
    }

    // reward_status: 0=初始, 1=標記送禮, 2=已送禮
    set_reward_status(b: any, newStatus: number) {
        if (b.reward_status === 2) return; // 已送禮不可變更
        const body: any = {
            user_id: b.user_id,
            status: newStatus,
            note: this.bd_reward_note || '',
        };
        this.httpClient.post<any>('/comm/set_birthday_reward.php', body).subscribe({
            next: (res: any) => {
                if (res?.status) {
                    b.reward_status = newStatus;
                    b.reward_dt = newStatus > 0 ? moment().format('YYYY-MM-DD HH:mm:ss') : '';
                    b.reward_by = res.operator || '';
                    this.bd_reward_note = '';
                } else if (res?.msg) {
                    alert(res.msg);
                }
            },
        });
    }

    get_next_reward_status(b: any): number {
        // 0→1, 1→2
        if (b.reward_status === 0) return 1;
        if (b.reward_status === 1) return 2;
        return b.reward_status;
    }

    get_reward_label(status: number): string {
        if (status === 1) return '標記送禮';
        if (status === 2) return '已送禮';
        return '初始';
    }

    batch_mark_all() {
        const initial = this.birthday_list_raw.filter(b => b.reward_status === 0);
        if (initial.length === 0) return;
        initial.forEach(b => {
            const body = { user_id: b.user_id, status: 1, note: '批次標記' };
            this.httpClient.post<any>('/comm/set_birthday_reward.php', body).subscribe({
                next: (res: any) => {
                    if (res?.status) {
                        b.reward_status = 1;
                        b.reward_dt = moment().format('YYYY-MM-DD HH:mm:ss');
                    }
                }
            });
        });
    }

    bd_toggle_sort(field: string) {
        if (this.birthday_sort_field === field) {
            this.birthday_sort_dir = this.birthday_sort_dir === 'asc' ? 'desc' : 'asc';
        } else {
            this.birthday_sort_field = field;
            this.birthday_sort_dir = field === 'income' ? 'desc' : 'asc';
        }
    }

    get_online_label(s: number): string {
        return s === 2 ? '在線' : s === 1 ? '忙碌' : '離線';
    }

    get_online_class(s: number): string {
        return s === 2 ? 'text-success' : s === 1 ? 'text-warning' : 'text-muted';
    }

    choose(id:string){
        this.now_vinfo = '';
        let tmp_data = {};
        this.now = id;
        this.pageobj.page = 0;
        if(id=='2'){
            this.edit_data = {phone_num:'',name:'',id:-1,profile_pic:''}
        }else if(id=='3'){
            this.sub_choose('0')
            return;
        }else if(id=='0'){
            Rtable.structure.type = 'txt';
            tmp_data = {
                name:{name:'會員名',type:'opt'},
                profile_pic:{name:'大頭貼',type:'img',type_cls_dk:'width50px'},
                phone_num:{name:'電話'},
                start_date:{name:'加入日',sort:1},
                regist_date:{name:'註冊日',sort:1},
                last_singin_date:{name:'最後上線',sort:1},
                //  os_type:{name:'裝置',type:'opt'},
                percent:{name:'經紀抽成',unit:'%',sort:1},
                pre_cut_diamond:{name:'加入前鑽石',sort:1},
                pre_cut_active:{name:'加入前活動鑽石',sort:1},
                login_time:{name:'平均上線',sort:1},
                ratio:{name:'平台匯率',sort:1},
                is_hidden:{name:'潛水',type:'opt',sort:1},
                sname:{name:'狀態',sort:1},
                studio:{name:'身分',type:'opt'},// 個人戶 / 工作室（vendor_member.is_studio、studio_name，get_u_list 用 v.* 帶回）
                auto_remove:{name:'自動退出',type:'opt',sort:1},
                lv:{name:'等級',sort:1},
                link:{name:'個人資料連結',type:'opt'},
                opt:{name:'設定',type:'opt'},
            }
            this.sort_obj = {column:'start_date',sort:'0'}
            this.posts_attributes = Rtable.init(tmp_data);
        }else if(id=='1'){
            Rtable.structure.type = 'num';
            tmp_data = {
                name:{name:'名稱',type:'opt'},
                now_round_diamond:{name:'本期鑽石',unit:'鑽',sort:1,type:'opt'},
                last_round_diamond:{name:'上期鑽石',unit:'鑽',sort:1,type:'opt'},
                last_round_money:{name:'上期提領',unit:'元',sort:1},
                total_diamond:{name:'累計鑽石',unit:'鑽',sort:1},
                total_money:{name:'累計提領',unit:'元',sort:1,type:'opt'},
                trade_num:{name:'交易對象',unit:'人',sort:1},
                opt:{name:'設定',type:'opt'}
            }
            this.posts_attributes = Rtable.init(tmp_data);
        }else if(id=='4'){
            Rtable.structure.type = 'txt';
            tmp_data = {
                name:{name:'淘妹名稱'},
                active_money:{name:'活動收入'},
                general_money:{name:'一般收入',type:'opt'},
                bonus_money:{name:'獎金收入'},
                pre_cut_diamond:{name:'預扣收入'},
                pre_cut_active:{name:'預扣活動收入',type:'opt'},
                accumulation_money:{name:'之前累積'},
                start_dt:{name:'計算日期'},
                end_dt:{name:'結算日期'},
                phone_num:{name:' 電話(備查)'},
                bvalue:{name:'收款行通匯代碼'},
                baccount:{name:'收款人帳號',type:'opt'},
                tax_id_num:{name:'收款人統編'},
                real_money:{name:'實際結算金額',type:'num',unit:'元',sort:1},
                baccountname:{name:'收款戶名'},
                id_name:{name:'姓名'},
                addr:{name:'地址'},
                birthday:{name:'生日'},
                total_money:{name:'收益金額',type:'num',unit:'元'},
                fee:{name:'代扣稅額',type:'num',unit:'元'},
                healthy_fee:{name:'代扣健保',type:'num',unit:'元'},
                id_number:{name:'身分證'},
                opt:{name:'提領方式設定',type:'opt'},
                actual_withdrawal_status:{name:'提領狀態',type:'opt'},
                actual_withdrawal_time:{name:'提領月份',type:'opt'},
                gg:{name:'個人資料設定',type:'opt'}
            }
            //this.bank_statement_attributes = Rtable.init(tmp_data);
            this.posts_attributes = Rtable.init(tmp_data);
        }else if(id=='5'){
            Rtable.structure.type = 'txt';
            tmp_data = {
                name:{name:'淘妹名稱'},
                id_name:{name:'姓名'},
                kycstatus:{name:'KYC審核'},
                bankstatus:{name:'銀行審核'},
                is_enable:{name:'帳戶狀態'},
                vm_status:{name:'代理狀態'},
                transfer_status:{name:'提領狀態'},
                acc:{name:'累積未匯'},
                start_dt:{name:'計算日期'},
                end_dt:{name:'結算日期'},
                phone_num:{name:' 電話(備查)'},
                real_money:{name:'實際匯款金額',type:'num',unit:'元'},
            }
            this.posts_attributes = Rtable.init(tmp_data);
        }else if(id == '6'){
            this.sub_choose('0');
            return; // sub_choose 內已觸發 init_list，不再往下重打（原本進頁共打 3 次）
        }

        if(id == '8'){
            this.rank_list();
        }else{
            this.init_list();
        }
    }

    onDateTyped(event: any) {
        const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
        if (!val) { return; }
        const parts = val.split(' - ');
        if (parts.length !== 2) { return; }
        let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
        let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
        if (!s.isValid() || !e.isValid()) { return; }
        if (s.isAfter(e)) { const t = s; s = e; e = t; }
        // 冪等：與目前範圍相同就不重複觸發（避免點選後 blur 又重查一次）
        if (this.time && this.time.start === s.format('YYYY-MM-DD') && this.time.end === e.format('YYYY-MM-DD')) { return; }
        this.onRangeSelected({ startDate: s, endDate: e });
    }

    onRangeSelected(value: any) {
        this.default_time = false;
        if(value.startDate){
            this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
            this.init_list();
        }
    }

    set_withdrawal_status(data: any, status: any){

        if(data.actual_withdrawal_status != '1'){
            Swal.fire({
                title: "確定要更改提領狀態?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "更改",
                cancelButtonText: "取消",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    const body = {data:data,type:9,status:status};
                    this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
                        this.loading = false;
                        if(res.status){

                            Swal.fire({
                                title: '已修改',
                                icon: "success"
                            });

                            this.init_list();

                        }else{
                            alert(res.message);
                        }
                    });

                }
            });

        }

    }


    set_withdrawal_time_status(data: any){
        Swal.fire({
            title: "確定要更改提領月份?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "更改",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {
                this.loading = true;
                const body = {data:data,type:10,actual_withdrawal_time:data.actual_withdrawal_time};
                this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){

                        Swal.fire({
                            title: '已修改',
                            icon: "success"
                        });
                    }else{
                        alert(res.message);
                    }

                    this.init_list();

                });

            }
        });

    }

    set_banktransfer_status(data: any, status: any){
        this.loading = true;
        const body = {data:data,type:7,status:status};
        this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.init_list();
            }else{
                alert(res.message);
            }
        });
    }

    show_diamond_detail(memo: any,data: any){
        console.log('memo',memo)
        this.subnow = "7";
        this.diamond_detail = data;
        memo.caculate.pre_cut_money = Math.floor(memo.data.pre_cut_diamond * this.diamond_detail.extra_exchange_rate);
        this.memo = memo;
    }

    // 活動鑽石匯率：2026 年(含)以後 0.068，之前 0.06
    // 停權提領有 money_month(陣列)用最後一個月；提領對帳表(vendor_member_withdrawal)沒有 money_month，改用結算日期 end_dt 判斷
    active_rate(detail: any){
        let mm = detail?.money_month;
        if(typeof mm === 'string'){
            try { mm = JSON.parse(mm); } catch(e){ mm = []; }
        }
        let latest = '';
        if(Array.isArray(mm) && mm.length > 0){
            latest = mm.reduce((a: string, b: string) => (a > b ? a : b));
        } else {
            latest = detail?.end_dt || detail?.actual_withdrawal_time || '';
        }
        return latest >= '2026' ? 0.068 : 0.06;
    }

    show_accounting_memo(data: any){
        this.subnow = "8";
        this.accounting_data = data;
        this.accounting_memo = data.memo[0].accounting_memo;
    }

    accounting_memo_save(){
        this.loading = true;
        const body = {data:this.accounting_data,type:8,memo:this.accounting_memo};
        this.httpClient.post<any>("/set_vendor.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.init_list();
            }else{
                alert(res.message);
            }
        });
    }

    checkDeviceType() {
        if (window.innerWidth > 768) { // 假設768px是切換點
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }
    }

    get_default(){
        this.inputFields = [{ value: '', userItem: null ,country_value:'886'}];
        this.add_inputFields = [];
        this.modalRef = this.modalService.open(this.brokerModal, { centered: true,size: 'lg' });
    }

    searchuser(value: string,index: any,country_value: string): void {
        if(value != ''){
            this.loading = true;
            //type = 0 搜尋用戶
            const body = {value:value,index:index,type:0,country_value:country_value};
            this.httpClient.post<any>("/cheack_request_user.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    this.inputFields[index].userItem = res.data;

                    if(res.data.identity != '3' && res.data.identity != '6' && res.data.identity != '99' && res.data.id > '0'){
                        this.inputFields = [{ value: '', userItem: null ,country_value:'886'}];
                        this.add_inputFields.push(res.data);
                    }

                }
            });
        }
    }

    removeInputField(index: number): void {
        this.add_inputFields.splice(index, 1);
    }

    add_user_identy() {
        if (this.add_inputFields.length > 0) {

            this.loading = true;

            //新增用戶
            this.add_inputFields.forEach((item: any) => {
                const body = {uid:item.uid,vid:this.vid};
                this.httpClient.post<any>("/join_vendor.php",body).subscribe(res => {
                    if(res.status){
                        Swal.fire({
                            title: '已新增此用戶到經紀',
                            icon: 'success',
                        });

                        if (this.modalRef) {
                            this.modalRef.close(); // 关闭模态框
                        }

                    }else{
                        Swal.fire({
                            title: res.message,
                            icon: 'error',
                        });
                    }
                });
            });

            this.loading = false;
            this.init_list();

        } else {
            Swal.fire({
                title: '沒有要新增的用戶',
                icon: 'info',
            });
        }
    }

    cancel_user_identy(){
        this.modalRef.close(); // 关闭模态框
    }

    cancel_user(item){

        this.loading = true;

        //type = 2 取消邀請用戶
        const body = {item:item,type:2};
        this.httpClient.post<any>("/cheack_request_user.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                Swal.fire({
                    title: '已取消邀請',
                    icon: 'success',
                });

                this.init_list();
            }
        });
    }

    updateVendorTargets(item: any) {
        // console.log("Dep:" + JSON.stringify(Dep.user));
        const body = {
            emp_id: Dep.user.id, // 預設管理者ID
            power_id: Dep.user.powers.power_id,
            vendor_list_id: item.id,
            daily_mass_message_target: item.daily_mass_message_target,
            featured_post_target: item.featured_post_target,
            monthly_target: item.monthly_target,
            recruitment_target: item.recruitment_target,
            type: 12,
        };
        this.httpClient.post<any>('/set_vendor.php', body).subscribe(res => {
              if (res.status) {
                alert("更新成功！");
                item.isEditing = false; // 成功後關閉編輯模式
              } else {
                alert("更新失敗：" + res.message);
              }
            },
            error => {
              console.error("API 請求錯誤", error);
              alert("發送請求失敗");
            }
        );
    }
}


